'use strict'
module.exports = {
  WORD_IGNORE_LIST: ["a", "an", "and", "at", "the", "of", "or", "by", "for", "in", "into", "it", "me", "my", "nor", "so", "to", "we", "you", "new", "that", "their","with","today","is","they","also","all","your"],
  GEMINI_DIMENSIONS: [
    {"name": "location", "color": "#3399ff", "weight": 100},
    {"name": "occupation","color": "#2eb82e", "weight": 20},
    {"name": "demographic","color":"#cc8800", "weight": 20},
    {"name": "education","color": "#8e83af", "weight": 50},
    {"name": "skills","color": "#aab300", "weight": 50}
  ],
  GEMINI_CONFIGS: [
    {"intent":"Assignment", "location":11, "occupation":11, "demographic":11, "education":11, "skills":11,"initial":1,"refill":1,"days":1,"responses":1},
    {"intent":"Academic Guidance", "location":30, "occupation":45, "demographic":25, "education":80, "skills":25,"initial":5,"refill":0,"days":3,"responses":2},
    {"intent":"Career Advice", "location":50, "occupation":100, "demographic":10, "education":25, "skills":25,"initial":4,"refill":2,"days":2,"responses":2},
    {"intent":"Entrepreneurship", "location":75, "occupation":30, "demographic":40, "education":25, "skills":90,"initial":9,"refill":2,"days":3,"responses":2},
    {"intent":"Internal", "location":11, "occupation":11, "demographic":11, "education":11, "skills":11,"initial":3,"refill":0,"days":1,"responses":1},
    {"intent":"Job Search", "location":80, "occupation":100, "demographic":60, "education":50, "skills":40,"initial":5,"refill":0,"days":3,"responses":2},
    {"intent":"Mentoring", "location":11, "occupation":11, "demographic":11, "education":11, "skills":11,"initial":2,"refill":2,"days":3,"responses":2},
    {"intent":"Networking", "location":11, "occupation":11, "demographic":11, "education":11, "skills":11,"initial":7,"refill":3,"days":3,"responses":4},
    {"intent":"Other", "location":100, "occupation":20, "demographic":20, "education":50, "skills":50,"initial":2,"refill":2,"days":1,"responses":1},
    {"intent":"Projects", "location":80, "occupation":20, "demographic":40, "education":25, "skills":100,"initial":2,"refill":0,"days":3,"responses":2}
  ],
  NEVER_ASKED_SCORE: 1.0,
  ENGAGEMENT_SCORE_PER_DAY: 0.03,
  ENGAGEMENT_SCORE_MAX_DAYS: 30,
  ENGAGEMENT_SCORE_EFFECT: 0.1,
  SUBTERM_SCORE: 0.5,
  GEMINI_RETURN_LIMIT: 300,
  GEMINI_QUERY_LIMIT: 200000
}


//////////////////
// WEBPACK FOOTER
// ./config/global.js
// module id = 5N5f
// module chunks = 1